const { createSlice } = require("@reduxjs/toolkit");

const collectionSubCategorySlice = createSlice({
  name: "collectionSubCategory",
  initialState: {
    collectionSubCategoryName: null,
  },
  reducers: {
    setcollectionSubCategory(state, action) {
      const collectionSubCategoryName = action.payload;

      return (state = {
        collectionSubCategoryName,
      });
    },
  },
});

export const { setcollectionSubCategory } = collectionSubCategorySlice.actions;
export default collectionSubCategorySlice.reducer;